export default __webpack_public_path__ + "static/media/folder.131f06eb.svg";